import Vue from 'vue'
import { formatDate } from './date-utils'

// filters
// format date (dd/mm/yyyy - 01/01/17)
Vue.filter('formatDate', function (value) {
  formatDate(value)
})
